<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
  margin:0;
  padding:0;
}
#app {
  position: absolute;
  top:0;
  bottom:0;
  width:100%;
  /* background-color: #000; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue